export const LOAD_CART = 'LOAD_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const DELETE_FROM_CART = 'DELETE_FROM_CART';
export const ADD_ONE_CART = 'ADD_ONE_CART';
export const REMOVE_ONE_CART = 'REMOVE_ONE_CART';
export const ESTIMATED_TOTAL = 'ESTIMATED_TOTAL';
